import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MemoriesService } from "../service/memories.service";
import { SidebarService } from 'src/app/core/services/sidebar.service';
@Component({
  selector: "app-memories-details",
  templateUrl: "./memories-details.component.html",
  styleUrls: ["./memories-details.component.css"],
})
export class MemoriesDetailsComponent implements OnInit {
  sidebarCollapsed: boolean = false;
  categories: string;
  subtitle: string;
  subroute: string;
  selectedCategory: any;
  selectedEvent: any;
  memoriesdata: any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private memories: MemoriesService,
    private sidebarService: SidebarService
  ) {}
  ngOnInit(): void {
    // Subscribe to sidebar collapsed state
    this.sidebarService.collapsed$.subscribe(collapsed => {
      this.sidebarCollapsed = collapsed;
    });
    
    this._getMemoriesCategories();
  }

  _getMemoriesCategories() {
    this.categories = this.route.snapshot.params["category"];
    this.memories.getMemoriesCategories(this.categories).subscribe((res) => {
      this.memoriesdata = res;
    });
  }

  navigateToSubroute(id:number) {
    this.router.navigate([`/memories/${this.categories}`,id]);
  }

}
